import React, { useState } from "react";
import { List, Grid, Card } from "antd";
import { orderBy } from "lodash";
import CreaItem from "../Crea/CreaItem";
import Localize from "../../libs/localization";
import ListLoader from "../ListLoader/ListLoader";

const { useBreakpoint } = Grid;

const CreaList = ({ data, loading, isDashboard = false }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  if (loading) {
    return (
      <ListLoader />
    );
  }

  if (!data || data.length === 0) {
    const emptyContent = (
      <div
        className="text-center"
        style={{
          color: "#999",
          padding: "40px 20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: isDashboard ? "150px" : "auto",
        }}
      >
        {Localize("PAGES.SEARCH.NO_DATA")}
      </div>
    );

    if (isDashboard) return emptyContent;

    return (
      <Card
        bordered={false}
        className="companyPage__body-card companyPage__body-card--custom customCard"
      >
        {emptyContent}
      </Card>
    );
  }

  const sortedData = orderBy(data, "date", "desc");
  const displayData = isDashboard ? sortedData.slice(0, 3) : sortedData;

  return (
    <List
      className="searchPage__list animation"
      itemLayout={isMobile ? "vertical" : "horizontal"}
      dataSource={displayData}
      renderItem={(item) => (
        <div className="searchPage__item-more animation fadein-right slow">
          <List.Item
            className="searchPage__item"
            style={isMobile ? { display: "block" } : {}}
          >
            <CreaItem item={item} />
          </List.Item>
        </div>
      )}
      pagination={
        isDashboard
          ? false
          : {
              pageSize: 10,
              showSizeChanger: false,
            }
      }
    />
  );
};

export default CreaList;
